import { createSlice } from '@reduxjs/toolkit';
import { updatedSelectedFilters, replaceSelectedFilters } from '@utils/search';
const initFilters = (state) => {
    return (state.refinements || []).map((refinement) => {
        return {
            id: refinement.attributeID,
            values: [],
        };
    });
};
export default createSlice({
    name: 'search',
    initialState: {
        cgid: undefined,
        cgids: undefined,
        shelf: {},
        filteredCategory: undefined,
        selectedFilters: [],
        filtersReady: false,
        selectedSort: '',
        results: [],
        refinements: [],
        sizeGroups: {},
        count: 0,
        progress: 0,
        pageSize: 12,
        pageNumber: 0,
        category: undefined,
        breadcrumbs: [],
        productSort: {
            options: [],
        },
        filterAction: undefined,
        resultsType: undefined,
        editorialcards: [],
        pageMetaTags: undefined,
        inSearch: false,
        inputSearch: '',
        showSearch: false,
        fromQuery: false,
        landingAnimation: false,
        firstLoad: true,
        suggestionPhrases: [],
        menuData: undefined,
    },
    reducers: {
        initResults: (state, action) => {
            var _a, _b, _c;
            const data = action.payload.data;
            // shelf management deprecated and unused
            if (!action.payload.isShelf && ((_a = data === null || data === void 0 ? void 0 : data.category) === null || _a === void 0 ? void 0 : _a.id)) {
                state.cgid = (_b = data === null || data === void 0 ? void 0 : data.category) === null || _b === void 0 ? void 0 : _b.id;
            }
            // shelf management deprecated and unused
            if (action.payload.isShelf) {
                state.shelf[(_c = action.payload) === null || _c === void 0 ? void 0 : _c.cgid] = {
                    count: data.count,
                    results: data.products,
                    breadcrumbs: data.breadcrumbs,
                    category: data.category,
                };
            }
            else {
                state.results = data.products;
                state.count = data.count;
                state.pageNumber = data.pageNumber;
                state.category = data.category;
                state.pageSize = data.pageSize;
                state.productSort = data.productSort;
                state.refinements = data.refinements;
                state.sizeGroups = data.sizeGroups;
                state.resultsType = action.payload.resultsType;
                state.progress = state.pageSize;
                state.breadcrumbs = data.breadcrumbs;
                state.pageMetaTags = data.pageMetaTags;
                // const selectedSortItem = data.productSort.options.find(({ sortingRuleId }) => sortingRuleId === data.productSort.ruleId);
                state.selectedSort = data.productSort.ruleId || '';
                state.editorialcards = data === null || data === void 0 ? void 0 : data.editorialcards;
                state.heroBannerSlim = data === null || data === void 0 ? void 0 : data.heroBannerSlim;
                state.featuredProductsCarousel = data === null || data === void 0 ? void 0 : data.featuredProductsCarousel;
                state.plpintro = data === null || data === void 0 ? void 0 : data.plpintro;
                state.suggestionPhrases = (data === null || data === void 0 ? void 0 : data.suggestionPhrases) || [];
            }
        },
        updateResults: (state, action) => {
            var _a, _b, _c, _d;
            const data = action.payload.data;
            if (data.searchKeywords != state.inputSearch && ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.target) !== 'LISTING') {
                return;
            }
            state.results = ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.resultsType) === 'REFINE' ? data.products : [...state.results, ...data.products];
            state.count = data.count;
            state.pageNumber = data.pageNumber;
            state.pageSize = data.pageSize;
            state.productSort = data.productSort;
            state.refinements = data.refinements;
            state.sizeGroups = data.sizeGroups;
            state.resultsType = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.resultsType;
            state.progress = ((_d = action.payload) === null || _d === void 0 ? void 0 : _d.resultsType) === 'REFINE' ? state.pageSize : state.progress + state.pageSize;
            state.suggestionPhrases = (data === null || data === void 0 ? void 0 : data.suggestionPhrases) || [];
            if (state.inSearch) {
                state.firstLoad = false;
            }
        },
        updateInput: (state, action) => {
            state.inSearch = true;
            state.progress = 0;
            if (action.payload === '') {
                state.results = [];
                state.suggestionPhrases = [];
            }
            state.inputSearch = action.payload;
            state.filteredCategory = undefined;
        },
        updateQuery: (state, action) => {
            state.querySearch = action.payload;
        },
        resetSearch: (state, action) => {
            state.results = [];
            state.count = 0;
            state.progress = 0;
            state.inputSearch = '';
            state.filteredCategory = undefined;
            state.selectedFilters = [];
            state.suggestionPhrases = [];
            state.firstLoad = true;
        },
        updateSearchVisibility: (state, action) => {
            if (!action.payload) {
                state.results = [];
                state.count = 0;
                state.progress = 0;
                state.inputSearch = '';
                state.filteredCategory = undefined;
                state.selectedFilters = [];
                state.suggestionPhrases = [];
                state.firstLoad = true;
            }
            state.fromQuery = false;
            state.showSearch = action.payload;
        },
        initFilters: (state, action) => {
            state.selectedFilters = initFilters(state);
        },
        addFilters: (state, action) => {
            const { filterId, valueId, id } = action.payload;
            if (id) {
                state.filteredCategory = id === 'all' ? undefined : id;
            }
            else {
                updatedSelectedFilters(state, filterId, valueId);
            }
        },
        replaceFilters: (state, action) => {
            const { filterId, valueId } = action.payload;
            replaceSelectedFilters(state, filterId, valueId);
        },
        resetFilter: (state, action) => {
            const { filterId } = action.payload;
            state.selectedFilters = state.selectedFilters.map((filter) => {
                if (!filterId || filter.id === filterId) {
                    filter.values = [];
                }
                return filter;
            });
        },
        updateSort: (state, action) => {
            state.selectedSort = action.payload;
        },
        updateFiltersFromQuery: (state, action) => {
            console.info('updateFiltersFromQuery');
            const query = decodeURIComponent(action.payload || '');
            if (action.payload) {
                const filtersString = query.split('|');
                console.log(filtersString);
                let updatedFilters = [];
                filtersString.forEach((filter) => {
                    var _a;
                    const splittedFilter = filter.split(':');
                    const filterKey = splittedFilter[0];
                    const filterItems = ((_a = splittedFilter[1]) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
                    if (filterKey) {
                        updatedFilters.push({ id: filterKey, values: filterItems });
                    }
                });
                state.selectedFilters = updatedFilters;
            }
            else {
                state.selectedFilters = [];
            }
        },
        updateSearchFromQuery: (state, action) => {
            console.info('updateSearchFromQuery');
            state.fromQuery = true;
            state.inSearch = true;
            // state.progress = 0;
            state.inputSearch = action.payload || '';
            state.querySearch = action.payload || '';
            // state.filteredCategory = undefined;
            // dovrebbe aprire la modale di ricerca
        },
        updateSearchCategoryFromQuery: (state, action) => {
            console.info('updateSearchCategoryFromQuery');
            state.filteredCategory = action.payload;
        },
        updateLandingAnimation: (state, action) => {
            state.firstLoad = false;
            state.landingAnimation = action.payload;
        },
        updateMenuData: (state, action) => {
            state.menuData = action.payload;
        },
    },
});
